import { ArrowLeft } from 'lucide-react'
import { Link } from 'react-router-dom'

function NotFoundPage() {
  return (
    <div className="page-container">
      <div className="not-found">
        <span>404</span>
        <h1>页面不存在</h1>
        <p>这个地址没有对应的榜单或项目页面。</p>
        <Link className="primary-button" to="/">
          <ArrowLeft size={17} /> 返回今日榜单
        </Link>
      </div>
    </div>
  )
}

export default NotFoundPage
